import { render, staticRenderFns } from "./en-IE.vue?vue&type=template&id=fba956a2&"
import script from "./en-IE.vue?vue&type=script&lang=js&"
export * from "./en-IE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba956a2')) {
      api.createRecord('fba956a2', component.options)
    } else {
      api.reload('fba956a2', component.options)
    }
    module.hot.accept("./en-IE.vue?vue&type=template&id=fba956a2&", function () {
      api.rerender('fba956a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/en-IE.vue"
export default component.exports